<cft-content-section
  [sectionId]="section.id"
  [plot]="section.plot"
  [title]="section.title"
  [description]="section.description"
  titleAlignment="left"
>
  <bgo-pro-directory
    [filter]="{
      industryIds: section.industryIds,
      offeringIds: section.offeringIds,
      location: section.location,
    }"
    [title]="section.title"
  ></bgo-pro-directory>
</cft-content-section>
